import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#FF6526" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink href="https://www.facebook.com/umamisushilangley/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Umami Sushi Japanese Restaurant Facebook"
              />
            </CFLink>
            {/*<CFLink href="https://www.instagram.com/explore/locations/297185451/canada/burnaby-british-columbia/sushi-uomo-japanese-restaurant/?hl=en">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Umami Sushi Japanese Restaurant Instagram"
              />
            </CFLink>*/}
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#FF6526" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink href="https://www.facebook.com/umamisushilangley/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Umami Sushi Japanese Restaurant Facebook"
                hover
              />
            </CFLink>
            {/*<CFLink href="https://www.instagram.com/explore/locations/297185451/canada/burnaby-british-columbia/sushi-uomo-japanese-restaurant/?hl=en">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Umami Sushi Japanese Restaurant Instagram"
                hover
              />
            </CFLink>*/}
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
